module.exports = __webpack_public_path__ + "images/emoji/last_quarter_moon.dde5188a609b5933ce2c.png";